var parent = require('../../es/object/define-properties');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/object/define-properties.js
// module id = 1124
// module chunks = 0